import _ from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck } from '@fortawesome/pro-solid-svg-icons'
import React, {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'
import { faFileAlt } from '@fortawesome/pro-solid-svg-icons'
import loading from '../media/loading.svg'
import { Dispatch, SubmitButton } from './architecture/frontend/index'

import { filter } from 'rxjs/operators'

function ResultsDropzone(props) {
  const onDrop = useCallback(acceptedFiles => {
    Dispatch.nextAction('shipments.importData', {file: acceptedFiles[0], type: 'results'})
  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop, accept: {"text/*": [".csv", ".xlsx"]}})
  return (
    <div className='pointer' {...getRootProps()}>
      <input {...getInputProps()} />
      {
          isDragActive ?
          <div className='bg-evonik-light-purple white pv3 ph3 br2 pointer'>
            Import Shipment Results
          </div> :
           <div className='bg-evonik-light-purple white pv3 ph3 br2 pointer'>
            Import Shipment Results
          </div>
      }
    </div>
  )
}

function ClaimResultsDropzone(props) {
  const onDrop = useCallback(acceptedFiles => {
    Dispatch.nextAction('shipments.importData', {file: acceptedFiles[0], type: 'claims'})
  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop, accept: {"text/*": [".csv", ".xlsx"]}})
  return (
    <div className='pointer' {...getRootProps()}>
      <input {...getInputProps()} />
      {
          isDragActive ?
          <div className='bg-evonik-light-purple white pv3 ph3 br2 pointer'>
            Import Claim Results
          </div> :
           <div className='bg-evonik-light-purple white pv3 ph3 br2 pointer'>
            Import Claim Results
          </div>
      }
    </div>
  )
}

const ImportShipment = (props) => {
  return (
    <div className='w-100 ph3'>
        <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' >
        <div className='flex items-center'>
          <FontAwesomeIcon className='relative f5 white' icon={faTruck} style={{top:-2}}/>
          <div className='pl2 fw7 f6 white'>Data Import</div>
          <div className='h2'></div>
        </div>
        {/* <div className='flex'>
          <div className='pv2 ph3 bg-evonik-light-purple br2 white f6 fw5'>
            Attach File to Selected
          </div>
          <div className='ml2 pv2 ph3 bg-evonik-light-purple br2 white f6 fw5'>
            Save
          </div>
        </div> */}
      </div>
      <div className='w-100 pt5'>
        {props?.company?.id === 3 ?
          <div className='w-100 flex items-center justify-center flex-column'>

            <SubmitButton id={'save'} className='w5 tc' 
                responseId='save'
                defaultChild={ props => (
                  <ResultsDropzone />
                )}
                loadingChild={ props => (
                    <div className='mh3 ' style={{width:28}}>
                      <img src={loading} alt='loading'/>
                    </div>
                )}
                errorChild={ props => (
                  <div className='pl3 f7 fw4 red tr pointer'>Error</div>
                )}
                loadingStream={
                  Dispatch.getAction('Request.importData')
                  }
                successStream={
                  Dispatch.getAction('Response.importData')
                    .pipe(
                      filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.importData) || !_.isNil(e.data.importData) ))),
                    )
                  }
                errorStream={
                  Dispatch.getAction('Response.importData')
                    .pipe(
                      filter(e => !_.isNil(e.errors)),
                    )}
              />

              <SubmitButton id={'save'} className='pt3 w5 tc' 
                responseId='save'
                defaultChild={ props => (
                  <ClaimResultsDropzone />
                )}
                loadingChild={ props => (
                    <div className='mh3 ' style={{width:28}}>
                      <img src={loading} alt='loading'/>
                    </div>
                )}
                errorChild={ props => (
                  <div className='pl3 f7 fw4 red tr pointer'>Error</div>
                )}
                loadingStream={
                  Dispatch.getAction('Request.importData')
                  }
                successStream={
                  Dispatch.getAction('Response.importData')
                    .pipe(
                      filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.importData) || !_.isNil(e.data.importData) ))),
                    )
                  }
                errorStream={
                  Dispatch.getAction('Response.importData')
                    .pipe(
                      filter(e => !_.isNil(e.errors)),
                    )}
              />

           
          </div>
        :
          <div>This company is currently not setup for importing shipments. Please contact Evonik or Corvia Tech to enable this feature.</div>
        }
      </div>
    </div>
  )
}

export default ImportShipment